

export const getUserLocation = async () => {
    const response = await fetch('https://ipapi.co/json');
    return await response.json();
};

export default getUserLocation;
